document.addEventListener('click', (event) => {
  if (event.target.matches('.js-print')) {
    // Prevent default event
    event.preventDefault();

    // Print site
    window.print();
  }
});



// WEBPACK FOOTER //
// ./src/javascripts/shared/print.js